// extracted by mini-css-extract-plugin
module.exports = {"image":"CardImage_image__2q2bo"};